import getAccounts from '../response/accounts/get.json';
import getAccountsTwo from '../response/accounts/get-2.json';
import getAllAccounts from '../response/accounts/get-all.json';
import accountsAlt from '../response/accounts/0600004457.json';
import singleAccount from '../response/accounts/get-1.json';
import addresses from '../response/accounts/addresses.json';
import bankAccount from '../response/accounts/payment-type-bank-account.json';
import creditCard from '../response/accounts/payment-type-credit-card.json';
import eft from '../response/accounts/payment-type-eft.json';
import grandparentAccountName from '../response/accounts/grandparentname.json';
import grandparentAccountNameCashLoadable from '../response/accounts/grandparentname-cash-loadable.json';
import grandparentAccountNameCashPreloaded from '../response/accounts/grandparentname-cash-preloaded.json';
import contractBalances from '../response/accounts/contract-balances.json';
import { Response } from 'miragejs';

export default function AccountRoutes() {
  // Get Account and All Accounts
  this.get('accounts-api/v1/accounts/contract/list/:grandParentId', (schema, request) => {
    const { grandParentId } = request.params;
    const { outObjectPage, pageSize, contractSearchMethod } = request.queryParams;

    if (contractSearchMethod === 'CONTRACT_NUMBER') return singleAccount;
    if (outObjectPage === '0' && pageSize === '0') return getAllAccounts;
    if (grandParentId === '0600004457') return accountsAlt;
    if (outObjectPage === '2') return getAccountsTwo;
    return getAccounts;
  });

  // Get Addresses
  this.get('accounts-api/v1/accounts/contract/address/:id', () => addresses);

  // Get Payment type
  this.get('accounts-api/v1/accounts/contract/:accountId/paymenttype', (schema, request) => {
    const { accountId } = request.params;

    return accountId === '0600008424' ?
      bankAccount :
      accountId === '0600008448' ?
        creditCard :
        eft;
  });

  // Make a payment
  this.post('/accounts-api/v1/accounts/contract/:accountId/payment/adjustment', (schema, request) => {
    const { amount } = JSON.parse(request.requestBody);

    return { 
      'documentId': '0000000',
      'balance': 500 - amount,
    };
  });

  // Get grandparent account ID and Name
  this.get('/accounts-api/v1/accounts/contract/:accountId/grandparentname', (schema, request) => {
    const { accountId } = request.params;

    return accountId === '0600004455' ?
      grandparentAccountName :
      accountId === '0500001387' ?
        grandparentAccountNameCashPreloaded :
        accountId === '0500001405' ?
          grandparentAccountNameCashLoadable :
          new Response(400, {}, { errors: 'Lorem Ipsum' });
  });

  // Get contract balances
  this.get('accounts-api/v1/accounts/contract/balance/:accountId', () => contractBalances);
}
